var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5L9 9.5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5L12 12.5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.908857 8.99886C0.908846 4.25656 4.76389 0.4 9.50443 0.4C14.245 0.4 18.1 4.25656 18.1 8.99886C18.1 13.7397 14.2473 17.5954 9.50875 17.5977C9.41813 17.6052 9.32688 17.5941 9.24063 17.565C9.15294 17.5354 9.07239 17.4879 9.0041 17.4254C8.93577 17.3629 8.88124 17.2868 8.84394 17.2021C8.80663 17.1174 8.78736 17.0259 8.78736 16.9333C8.78736 16.8408 8.80663 16.7493 8.84394 16.6646C8.88127 16.5798 8.93582 16.5039 9.0041 16.4414C9.07239 16.379 9.15294 16.3314 9.24063 16.3018C9.32676 16.2727 9.41799 16.2615 9.5087 16.269C13.5244 16.2667 16.7628 13.017 16.7628 8.99886C16.7629 4.97936 13.5223 1.73764 9.50443 1.73764C5.48644 1.73764 2.23717 4.97951 2.23718 8.99886C2.23718 10.9708 3.03088 12.7488 4.30488 14.057V12.4041C4.30091 12.238 4.35917 12.0763 4.46825 11.9508C4.57751 11.8251 4.72988 11.7448 4.89537 11.7259C4.99036 11.7143 5.08675 11.7233 5.17798 11.7524C5.26934 11.7815 5.35333 11.83 5.42422 11.8945C5.49512 11.959 5.55129 12.038 5.58888 12.1262C5.62629 12.214 5.64441 12.3088 5.64205 12.4042L5.64205 15.7998C5.64205 15.7998 5.64205 15.7999 5.64205 15.7999V15.8001H5.54205C5.54234 15.8749 5.52782 15.949 5.49935 16.0182C5.47088 16.0873 5.42901 16.1501 5.37615 16.203C5.32329 16.2559 5.2605 16.2977 5.19139 16.3262C5.12227 16.3547 5.04821 16.3693 4.97346 16.369L0.908857 8.99886ZM0.908857 8.99886C0.908869 11.3994 1.89853 13.5705 3.48716 15.1313L0.908857 8.99886Z",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.6003697ff64b3c54cd6e7b5e63756202.svg";
export { ForwardRef as ReactComponent };